import dayjs from 'dayjs';
import { LOCAL_DATE_FORMAT } from '../../constants';

const calculateAge = (data) => {
    if (data && data.data && data.data.user_yearOfBirth && dayjs(data.data.user_yearOfBirth).isValid()) {
        return dayjs().diff(data.data.user_yearOfBirth, "year");
    }
    // dob is invalid or null, so render nothing
    return null;
}

const getName = (data) => {
    return data.data.user_firstName + " " + data.data.user_middleName + " " + data.data.user_lastName;
}

const isLateEntry = (params) => {
    if (params.data.user_ride_from_airport === "YES" && (Math.abs(dayjs().diff(dayjs(params.data.user_arrivingFlightDate + " " + params.data.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) && (Math.abs(dayjs(params.data.user_arrivalUpdatedAt).diff(dayjs(params.data.user_arrivingFlightDate + " " + params.data.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) && (dayjs().isBefore(dayjs(params.data.user_arrivingFlightDate + " " + params.data.user_arrivingFlightTime + "+05:30")))) {
        return "*"
    }

    // dob is invalid or null, so render nothing
    return null;
}

const formatDatetTime = (data) => {
    if (data && data.data && data.data.updatedAt && dayjs(data.data.updatedAt).isValid()) {
        return dayjs(data.data.updatedAt).format(LOCAL_DATE_FORMAT + " HH:mm");
    }
    // dob is invalid or null, so render nothing.
    return null;
}

const formatArrivalUpdatedDate = (data) => {
    if (data && data.data && data.data.user_arrivalUpdatedAt && dayjs(data.data.user_arrivalUpdatedAt).isValid()) {
        return dayjs(data.data.user_arrivalUpdatedAt).format(LOCAL_DATE_FORMAT + " HH:mm");
    }
    // dob is invalid or null, so render nothing.
    return null;
}

const getSaravanShortName = (data) => {
    if (data && data.data && data.data.user_saravan) {
        switch (data.data.user_saravan) {
            case "GOBIND SARVAR NIVAAS":
                return "GS";
            case "KOTHI NIVAAS":
                return "KOTHI";
            case "NAAM NIVAAS":
                return "NN";
            case "NIRBHAU NIVAAS":
                return "NBN";
            case "SEHAJ NIVAAS":
                return "SN";
         default:
                return data.data.user_saravan;
        }
    }
    return null;
}



    export const allColumns = [
        { field: "user_firstName", headerName: "First Name", sortable: true, filter: true },
        { field: "user_middleName", headerName: "Middle Name", sortable: true, filter: true },
        { field: "user_lastName", headerName: "Last Name", sortable: true, filter: true },
        { field: "user_age", headerName: "Age", sortable: true, filter: true, valueGetter: (data) => calculateAge(data) },
        { field: "user_city", headerName: "City", sortable: true, filter: true },
        { field: "user_country", headerName: "Country", sortable: true, filter: true },
        { field: "user_goingToAsthan", headerName: "Asthan", sortable: true, filter: true },
        { field: "user_ride_from_airport", headerName: "Ride", sortable: true, filter: true },
        { field: "user_arrivingFlightDate", headerName: "Arr. Date", sortable: true, filter: true },
        { field: "user_arrivingFlightTime", headerName: "Arr. Time", sortable: true, filter: true },
        { field: "user_arrivingFlightAirport", headerName: "Arr. Airport", sortable: true, filter: true },
        { field: "user_arrivingFlightName", headerName: "Arr. Airline", sortable: true, filter: true },
        { field: "user_arrivingFlightNumber", headerName: "Arr. Flight", sortable: true, filter: true },
        { field: "updatedAt", headerName: "Last updated (UTC Timezone)", sortable: true, filter: true },
        { field: "user_last_updated_by", headerName: "Last updated by", sortable: true, filter: true },
        { field: "user_phoneNumber", headerName: "Phone", sortable: true, filter: true },
        { field: "user_departingFlightNumber", headerName: "Ret. Flight", sortable: true, filter: true },
        { field: "user_departingFlightName", headerName: "Ret. Airline", sortable: true, filter: true },
        { field: "user_departingFlightAirport", headerName: "Ret. Airport", sortable: true, filter: true },
        { field: "user_departingFlightDate", headerName: "Ret. Airport", sortable: true, filter: true },
        { field: "user_departingFlightTime", headerName: "Ret. Time", sortable: true, filter: true },
        { field: "user_email", headerName: "Email", sortable: true, filter: true },
        { field: "user_comments", headerName: "Comments", sortable: true, filter: true, resizable: true },
        { field: "user_emergencyContact", headerName: "Emergency Contact", sortable: true, filter: true, resizable: true },
        { field: "user_state", width: 100, headerName: "State", sortable: true, filter: true },
        { field: "user_gender", headerName: "Gender", sortable: true, filter: true },
    ]

    export const arrivalReport = [
        { field: "user_firstName", headerName: "First Name", sortable: true, filter: true },
        { field: "user_middleName", headerName: "Middle Name", sortable: true, filter: true },
        { field: "user_lastName", headerName: "Last Name", sortable: true, filter: true },
        { field: "user_phoneNumber", headerName: "Phone", sortable: true, filter: true },
        { field: "user_gender", headerName: "Gender", sortable: true, filter: true },
        { field: "user_age", headerName: "Age", sortable: true, filter: true, valueGetter: (data) => calculateAge(data) },
        { field: "user_city", headerName: "City", sortable: true, filter: true },
        { field: "user_country", headerName: "Country", sortable: true, filter: true },
        { field: "user_goingToAsthan", headerName: "Asthan", sortable: true, filter: true },
        { field: "user_ride_from_airport", headerName: "Ride", sortable: true, filter: true },
        { field: "user_arrivingFlightDate", headerName: "Arr. Date", sortable: true, filter: true },
        { field: "user_arrivingFlightTime", headerName: "Arr. Time", sortable: true, filter: true },
        { field: "user_arrivingFlightAirport", headerName: "Arr. Airport", sortable: true, filter: true },
        { field: "user_arrivingFlightName", headerName: "Arr. Airline", sortable: true, filter: true },
        { field: "user_arrivingFlightNumber", headerName: "Arr. Flight", sortable: true, filter: true },
        { field: "updatedAt", headerName: "Last updated (UTC Timezone)", sortable: true, filter: true, valueGetter: (data) => formatDatetTime(data) }
    ]

    export const taxiReport = [
        { field: "user_arrivalUpdatedAt", headerName: "Arr. Updated At", sortable: true, filter: true, valueGetter: (data) => formatArrivalUpdatedDate(data) },
        { field: "user_arrivingFlightAirport", width: 150, headerName: "Arr. Airport", sortable: true, filter: true },
        { field: "user_arrivingFlightDate", width: 150, headerName: "Arr. Date", sortable: true, filter: true },
        { field: "user_arrivingFlightTime", width: 150, headerName: "Arr. Time", sortable: true, filter: true },
        { field: "user_arrivingFlightName", width: 150, headerName: "Arr. Airline", sortable: true, filter: true },
        { field: "user_arrivingFlightNumber", width: 150, headerName: "Arr. Flight", sortable: true, filter: true },
        { field: "user_firstName", width: 140, headerName: "First Name", sortable: true, filter: true },
        { field: "user_middleName", width: 100, headerName: "Middle Name", sortable: true, filter: true },
        { field: "user_lastName", width: 100, headerName: "Last Name", sortable: true, filter: true },
        { field: "user_age", width: 75, headerName: "Age", sortable: true, filter: true, valueGetter: (data) => calculateAge(data) },
        { field: "user_city", width: 140, headerName: "City", sortable: true, filter: true },
        { field: "user_country", width: 100, headerName: "Country", sortable: true, filter: true },
        { field: "user_ride_from_airport", width: 85, headerName: "Ride", sortable: true, filter: true },
        { field: "", headerName: "Taxi arranged", sortable: true, filter: true },
        { field: "updatedAt", headerName: "Last updated by", sortable: true, filter: true, valueGetter: (data) => formatDatetTime(data) },
    ]

    export const roomReport = [
        { field: "user_saravan", width: 75, headerName: "Saravan", sortable: true, filter: true, valueGetter: (data) => getSaravanShortName(data) },
        { field: "user_room", width: 125, headerName: "Room", sortable: true, filter: true },
        { field: "user_firstName",  width: 300, headerName: "Name", sortable: true, filter: true, valueGetter: (data) => getName(data) },
        { field: "user_gender", width: 100, headerName: "Gender", sortable: true, filter: true },
        { field: "user_age", width: 90, headerName: "Age", sortable: true, filter: true, valueGetter: (data) => calculateAge(data) },
        { field: "user_city", width: 150, headerName: "City", sortable: true, filter: true },
        { field: "user_goingToAsthan", width: 150, headerName: "Asthan", sortable: true, filter: true },
        { field: "user_ride_from_airport", width: 75,  headerName: "Ride", sortable: true, filter: true },
        { field: "user_arrivingFlightDate", width: 150, headerName: "Arr. Date", sortable: true, filter: true },
        { field: "user_arrivingFlightTime", width: 150, headerName: "Arr. Time", sortable: true, filter: true },
        { field: "user_arrivingFlightAirport", width: 150, headerName: "Arr. Airport", sortable: true, filter: true },
        { field: "user_arrivalUpdatedAt", width: 200, headerName: "Arr. Updated At", sortable: true, filter: true, valueGetter: (data) => formatArrivalUpdatedDate(data) },
        { field: "user_last_updated_by", width: 150, headerName: "Last updated by", sortable: true, filter: true }
    ]

    export const returnSangatReport = [
        { field: "user_departingFlightNumber", headerName: "Ret. Flight", sortable: true, filter: true },
        { field: "user_departingFlightName", headerName: "Ret. Airline", sortable: true, filter: true },
        { field: "user_departingFlightAirport", headerName: "Ret. Airport", sortable: true, filter: true },
        { field: "user_departingFlightDate", headerName: "Ret. Date", sortable: true, filter: true },
        { field: "user_departingFlightTime", headerName: "Return Time", sortable: true, filter: true },
        { field: "updatedAt", headerName: "Last updated (UTC Timezone)", sortable: true, filter: true, valueGetter: (data) => formatDatetTime(data) },
        { field: "user_firstName", headerName: "First Name", sortable: true, filter: true },
        { field: "user_middleName", headerName: "Middle Name", sortable: true, filter: true },
        { field: "user_lastName", headerName: "Last Name", sortable: true, filter: true },
        { field: "user_gender", headerName: "Gender", sortable: true, filter: true },
        { field: "user_age", headerName: "Age", sortable: true, filter: true, valueGetter: (data) => calculateAge(data) },
        { field: "user_city", headerName: "City", sortable: true, filter: true },
        { field: "user_country", headerName: "Country", sortable: true, filter: true },
        { field: "user_phoneNumber", headerName: "Phone", sortable: true, filter: true },
        { field: "user_email", headerName: "Email", sortable: true, filter: true },
        { field: "user_comments", headerName: "Comments", sortable: true, filter: true, resizable: true },
        { field: "user_emergencyContact", headerName: "Emergency Contact", sortable: true, filter: true, resizable: true },
        { field: "user_state", width: 100, headerName: "State", sortable: true, filter: true },
    ]

    export const babaJiReport = [
        { field: "user_firstName", headerName: "First Name", sortable: true, filter: true },
        { field: "user_middleName", headerName: "Middle Name", sortable: true, filter: true },
        { field: "user_lastName", headerName: "Last Name", sortable: true, filter: true },
        { field: "user_age", headerName: "Age", sortable: true, filter: true, valueGetter: (data) => calculateAge(data) },
        { field: "user_city", headerName: "City", sortable: true, filter: true },
        { field: "user_country", headerName: "Country", sortable: true, filter: true },
        { field: "user_ride_from_airport", headerName: "Ride", sortable: true, filter: true },
        { field: "user_arrivingFlightDate", headerName: "Date", sortable: true, filter: true },
        { field: "user_arrivingFlightTime", headerName: "Time", sortable: true, filter: true },
        { field: "user_arrivingFlightAirport", headerName: "Airport", sortable: true, filter: true }

    ]


